import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getAlertMessageFunction, getTotal, sanitizeList } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  s11Data: {},

  // 연금저축
  s11_1Data: {
    htm177: '',
    list: [],
  },
  // 장기주택
  s11_2Data: [],
  // 투자조합
  s11_3Data: [],
  // 우리사주
  s11_4Data: {
    htm017: '',
    htm048: '',
    htm053: '',
    htm143: '',
    htm172: '',
    htm173: '',
    htm175: '',
    htm180: '',
    htm181: '',
  },
  // 세액공제
  s11_5Data: {},
  s11_5total: 0,
  // 합계
  total: 0,
  //주택자금 상세
  housingFundsDetail: [],

  selectedHousingFundsDetail: {},

  //급여
  salary: 0,
  initMedicalDetail: {},

  checkList1: [],
  detailReload: -1,

  detailData: {},
  detailDataList: [],
};

//기타 불러오기
export const getOtherDeductionsData = createAsyncThunk(
  'otherDeductions/getOtherDeductionsData',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S11`);
    return response;
  },
);

//연금저축 불러오기
export const getOtherDeductionsData1 = createAsyncThunk(
  'otherDeductions/getOtherDeductionsData1',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1110`);
    return response;
  },
);

//장기집합
export const getOtherDeductionsData2 = createAsyncThunk(
  'otherDeductions/getOtherDeductionsData2',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1120`);
    return response;
  },
);

//투자조합
export const getOtherDeductionsData3 = createAsyncThunk(
  'otherDeductions/getOtherDeductionsData3',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1130`);
    return response;
  },
);

//우리사주
export const getOtherDeductionsData4 = createAsyncThunk(
  'otherDeductions/getOtherDeductionsData4',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1140`);
    return response;
  },
);

//세액공제
export const getOtherDeductionsData5 = createAsyncThunk(
  'otherDeductions/getOtherDeductionsData5',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1150`);
    return response;
  },
);

//기타저장
export const saveOtherDeductionsData = createAsyncThunk(
  'otherDeductions/saveOtherDeductionsData',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S11E`, data);
    return response;
  },
);

//기타삭제
export const deleteOtherDeductionsData = createAsyncThunk(
  'otherDeductions/deleteOtherDeductionsData',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S11D`, data);
    return response;
  },
);

const otherDeductionsSlice = createSlice({
  name: 'otherDeductionsSlice',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },

    setReload: (state, action) => {
      state.reload = Math.random();
    },
    setDetailReload: (state, action) => {
      state.detailReload = Math.random();
    },

    resetOtherDeductionsState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getOtherDeductionsData.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    // 주택자금 리스트
    builder.addCase(getOtherDeductionsData.fulfilled, (state, action) => {
      console.log('기타 리스트 >>', action.payload);
      const { htmJType } = action.payload;
      if (action.payload) {
        state.s11Data = action.payload;
      } else {
        state.s11Data = {};
      }

      state.isRender = true;
    });
    // 연금저축
    builder.addCase(getOtherDeductionsData1.fulfilled, (state, action) => {
      console.log('연금저축 리스트 >>', action.payload);
      const { htm177, list } = action.payload;

      state.s11_1Data = { htm177: htm177 || '', list: list || [] };
    });
    // 장기집합
    builder.addCase(getOtherDeductionsData2.fulfilled, (state, action) => {
      console.log('장기집합 리스트 >>', action.payload);
      state.s11_2Data = action.payload;
    });
    // 투자조합
    builder.addCase(getOtherDeductionsData3.fulfilled, (state, action) => {
      console.log('투자조합 리스트 >>', action.payload);
      state.s11_3Data = action.payload;
    });
    // 우리사주
    builder.addCase(getOtherDeductionsData4.fulfilled, (state, action) => {
      console.log('우리사주 리스트 >>', action.payload);
      state.s11_4Data = action.payload || {};
    });
    // 세액공제
    builder.addCase(getOtherDeductionsData5.fulfilled, (state, action) => {
      console.log('세액공제 리스트 >>', action.payload);
      state.s11_5Data = action.payload || {};
      state.s11_5total = getTotal(
        [action.payload || {}],
        ['htm035', 'htm036', 'htm055', 'htm124', 'htm125'],
      );
    });
    // 기타삭제
    builder.addCase(deleteOtherDeductionsData.fulfilled, (state, action) => {
      console.log('기타삭제 리스트 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode == 'OK') {
        state.detailReload = Math.random();
        state.reload = Math.random();
      }
    });
    //기타저장
    builder.addCase(saveOtherDeductionsData.fulfilled, (state, action) => {
      console.log('기타저장 리스트 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode == 'OK') {
        state.detailReload = Math.random();
        state.reload = Math.random();
      }
    });
  },
});

export const { confirmDelete, resetOtherDeductionsState, setReload, setDetailReload } =
  otherDeductionsSlice.actions;
export default otherDeductionsSlice.reducer;
